import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { SYMBOL } from '../../../brands/default/constants';
import { PREFORMATTED_STRING } from '../../../brands/default/content/components/checkout';
import { LINK_ECOMMERCE_TERMS } from '../../../brands/default/links';
import {
  CROWN_ICON,
  TAG_ICON,
  TROPHY_ICON,
} from '../../../config/constants/images';
import { formatPrice } from '../../../helpers/currency';
import ThemeContext from '../../../providers/ThemeProvider';

const VipPostButtonMessage = ({
  currencySymbol,
  discount,
  isBeginOpen = true,
  vipOneYearCost,
}) => {
  const theme = useContext(ThemeContext);
  const displayDiscount = formatPrice(discount, true);
  const isDiscountGreaterVipYearCost = discount > vipOneYearCost;
  const [isOpen, setIsOpen] = useState(isBeginOpen);
  const chevronIcon = isOpen ? faCaretUp : faCaretDown;

  const handleButtonClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div className="message-container">
        <div className="message">
          <div className="vip-caret">
            <FontAwesomeIcon
              color={theme.commoncolors.grey}
              icon={chevronIcon}
              onClick={handleButtonClick}
            />
          </div>

          <p className="paragraph-one">
            <b>
              {isDiscountGreaterVipYearCost && (
                <>
                  Join {PREFORMATTED_STRING.brandTerminology.brand} VIP to{' '}
                  <span className="primary">
                    SAVE <br /> an additional {currencySymbol}
                    {displayDiscount} NOW
                  </span>{' '}
                  and get <br />
                  access to the following:
                </>
              )}{' '}
              {!isDiscountGreaterVipYearCost && isBeginOpen && (
                <>
                  Join {PREFORMATTED_STRING.brandTerminology.brand} VIP and get
                  access to the following:
                </>
              )}{' '}
              {!isDiscountGreaterVipYearCost && !isBeginOpen && (
                <>
                  Join {PREFORMATTED_STRING.brandTerminology.brand} VIP to
                  benefit from EXCLUSIVE deals, codes, discount and more!
                </>
              )}{' '}
            </b>
          </p>
          {isOpen && (
            <>
              <ul className="list">
                <li className="list-item list-item-crown">
                  <span className="primary">EXTRA DISCOUNT ON</span> eligible
                  deals saving you more! Don&#39;t miss out!
                </li>
                <li className="list-item list-item-tag">
                  Qualify for <span className="primary">COMPLEMENTARY</span> and{' '}
                  <span className="primary">EXCLUSIVE</span> products from our
                  top merchants!
                </li>
                <li className="list-item list-item-trophy">
                  <span className="primary">FREE ENTRY</span> into all of our
                  competitions. You could be in with a chance to{' '}
                  <span className="primary">win</span> prizes of up to{' '}
                  <span className="primary">{`${SYMBOL}20,000!`}</span>
                </li>
              </ul>
              <p style={{ textAlign: 'center' }}>
                View VIP T&Cs{' '}
                <a
                  href={LINK_ECOMMERCE_TERMS.href + '#vip'}
                  rel="noreferrer"
                  target="_blank"
                >
                  here
                </a>
              </p>
            </>
          )}
        </div>
      </div>
      <style jsx>{`
        .message-container {
          margin: 0 -15px -15px -15px;
          padding-top: 15px;
        }
        .message {
          background-color: ${theme.commoncolors.greyx2lighter};
          border-radius: 0 0 7px 7px;
          color: ${theme.commoncolors.black};
          padding: 15px;
        }
        .paragraph-one {
          font-size: 16px;
          margin: ${
            isDiscountGreaterVipYearCost
              ? '0 0 15px 0;'
              : '15px 30px 15px 30px;'
          }
          text-align: center;
        }
        .list {
          margin-left: auto;
          margin-right: auto;
          padding: 0;
          width: 95%;
        }
        .list-item {
          background-position: 0 5px;
          background-repeat: no-repeat;
          background-size: 45px;
          font-size: 14px;
          list-style: none;
          margin-bottom: 10px;
          padding-left: 60px;
        }
        .list-item-crown {
          background-image: url(${CROWN_ICON});
        }
        .list-item-tag {
          background-image: url(${TAG_ICON});
          background-size: 40px;
        }
        .list-item-trophy {
          background-image: url(${TROPHY_ICON});
        }
        .primary {
          color: ${theme.colors.primary};
          font-weight: bold;
        }
        .vip-caret {
          color: ${theme.colors.primary};
          cursor: pointer;
          font-size: 3rem;
          padding-right: 25px;
          position: absolute;
          right: 0;
        }
        @media (min-width: ${theme.breakpoints.xxs}) {
          .paragraph-one {
            font-size: 18px;
          }
          .list-item {
            font-size: 16px;
          }
        }
        @media (min-width: ${theme.breakpoints.xs}) {
          .list {
            width: 60%;
          }
        }
        @media (min-width: ${theme.breakpoints.smUp}) {
          .list {
            width: 50%;
          }
          .list-item {
            font-size: 16px;
          }
        }
        @media (min-width: ${theme.breakpoints.mdUp}) {
          .list {
            width: 50%;
          }
        }
        @media (min-width: ${theme.breakpoints.lgUp}) {
          .list {
            width: 70%;
          }
        }
      `}</style>
    </>
  );
};

VipPostButtonMessage.propTypes = {
  currencySymbol: PropTypes.string,
  discount: PropTypes.number,
  isBeginOpen: PropTypes.bool,
  vipOneYearCost: PropTypes.number,
};

export default VipPostButtonMessage;
